import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import AdminUserStore from '@store/admin/AdminUserStore';
import {RouterLocation} from '@store/@types/util/ReactRouter';
import {getQuery} from 'utils/getQueryParam';
import {AdminUserList} from '@components/admin/AdminUserList';
import TeamListStore from 'stores/TeamListStore';
import DepartmentStore from 'stores/department/DepartmentStore';
import AccountStore from 'stores/AccountStore';
import TeamActions from 'actions/TeamActions';
import AuthStore from 'stores/AuthStore';
import DepartmentActions from 'actions/department/DepartmentActions';
import AccountActions from 'actions/AccountActions';
import WebDataRocksOverlay from 'components/dashboard/WebDataRocksOverlay';
import moment from 'moment';

interface AdminUserListContainerProps {
  location: RouterLocation;
}

interface AdminUserListContainerState {}

@connectToStores
export default class AdminUserListContainer extends React.PureComponent<
  AdminUserListContainerProps & ReturnType<typeof AdminUserListContainer.getPropsFromStores>,
  AdminUserListContainerState
> {
  static getStores() {
    return [AdminUserStore, TeamListStore, DepartmentStore, AccountStore, AuthStore];
  }

  static getPropsFromStores(props: AdminUserListContainerProps) {
    const {users, usersLoading, total} = AdminUserStore.getState();
    const {teams} = TeamListStore.getState();
    const {departmentProfiles} = DepartmentStore.getState();
    const {hasSlack, hasSlackLoaded} = AccountStore.getState();
    const {user} = AuthStore.getState();
    return {
      users,
      usersLoading,
      query: getQuery(props.location),
      teams,
      departmentProfiles,
      showSlack: hasSlack && hasSlackLoaded,
      sessionUser: user,
      totalResults: total,
      hasSlackLoaded,
      tenantId: user.tenantId,
    };
  }

  componentDidMount() {
    const {sessionUser} = this.props;
    DepartmentActions.fetchDepartmentProfiles(sessionUser.isAdmin());
    TeamActions.fetchAllTeamsForAdmin();
    AccountActions.hasSlack();
  }

  render() {
    return (
      <>
        <WebDataRocksOverlay startDate={moment()} endDate={moment()} />
        <AdminUserList {...this.props} />
      </>
    );
  }
}
